export const siteTypes = {
    SERVICE: 'service',
    SPACE: 'space',
    EVENT: 'event',
    MEETINGROOM: 'room'
}